import { render, staticRenderFns } from "./barChartDashboard.vue?vue&type=template&id=3c99e871&scoped=true"
import script from "./barChartDashboard.vue?vue&type=script&lang=js"
export * from "./barChartDashboard.vue?vue&type=script&lang=js"
import style0 from "./barChartDashboard.vue?vue&type=style&index=0&id=3c99e871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99e871",
  null
  
)

export default component.exports